import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

/*
 * Converts datetime to local time
 *
 * Usage:
 *   value | localizeTime
 */
@Pipe({
    name: 'localizeTime',
    standalone: false
})
export class LocalizeTimePipe implements PipeTransform {
    transform(value: string | Date, format: string): string {
        return moment(value).format(format);
    }
}
